import { createFileRoute } from '@tanstack/react-router';
import { LoginScreen } from '~/components/auth/LoginScreen';

/**
 * TEMPORARY design-preview route — renders the login visual WITHOUT the
 * auth redirect, so the login page can be iterated on while signed in.
 * Remove this file before shipping.
 */
export const Route = createFileRoute('/login-preview')({
  component: LoginScreen,
});
